import * as yup from "yup";
const BiographySchema = yup.object({
  biography: yup
    .string('Describe yourself in 300-500 Words.')
    .min(300, 'Biography should be of minimum 300 characters length')
    .max(500, 'Biography should be of maximum 500 characters length')
    .required('Biography is required')
});
const ExperienceSchema = yup.object({
  description: yup
    .string('Describe yourself in 200-250 Words.')
    .min(200, 'Description should be of minimum 200 characters length')
    .max(250, 'Description should be of maximum 250 characters length')
    .required('Description is required'),
  title: yup
    .string('Work title')
    .required('title is required'),
  yearOfWork: yup
    .string('Year of work')
    .required('Year of work is required')
});
const projectSchema = yup.object({
  description: yup
    .string('Describe yourself in 200-250 Words.')
    .min(100, 'Description should be of minimum 200 characters length')
    .max(150, 'Description should be of maximum 250 characters length')
    .required('Description is required'),
  title: yup
    .string('Work title')
    .required('title is required'),
  role: yup
    .string('Year of work')
    .required('Year of work is required'),
  cover: yup
    .string('Cover'),
  imdbLink: yup
    .string('IMDB link').url().nullable(),
  mediaFiles: yup
    .array().of(yup.string())
});
/*
*
*
*
over
title
role
imdbLink
description
mediaFiles
*
* */
const wokHistoryValidation = {
  biography:{
    initialValues: {
      biography: ''
    },
    validation: BiographySchema
  },
  experience: {
    initialValues: {
      description: '',
      title: '',
      yearOfWork: ''
    },
    validation: ExperienceSchema
  },
  project: {
    initialValues: {
      description: '',
      title: '',
      role: '',
      cover: '',
      imdbLink: '',
      mediaFiles: '',
    },
    validation: projectSchema
  }
};
export default wokHistoryValidation;